
import 'bootstrap/dist/css/bootstrap.min.css';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { getDecoded } from './AuthWrapper';

//import NavDropdown from 'react-bootstrap/NavDropdown';

function Navigation(props) {
  var body = getDecoded();

  var role = "";
  if(body.role === "CI"){
    role = "(" + body.role + ", " + body.ciClub + ")"
  }
  if(body.role === "RI"){
    role = "(" + body.role + ")"
  }

  return (
    <Navbar expand="lg" className="bg-body-tertiary" style={{ marginBottom: "20px" }}>
      <Container>
        <Navbar.Brand href="/#">Rapportering</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/#">Meny</Nav.Link>
            {/**
                  <NavDropdown title="Skapa" id="basic-nav-dropdown">
                    <NavDropdown.Item href="#action/3.1">Röd - incident</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.2">Blå - händelse</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.3">Gul - reservdrag</NavDropdown.Item>
                  </NavDropdown>
                  */}
          </Nav>
          <form className="form-inline my-2 my-lg-0 float-right" action="/logout" method="POST">
            <span className="navbar-text my-2 my-sm-0">
              Inloggad som {body.sub  + " " + role} &nbsp;
            </span>
            <button type="button" className="btn btn-outline-secondary my-2 my-sm-0" onClick={(e) => props.logout.logoutFunc()}>Logga ut</button>
          </form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;